import { Switch as SwitchPrimitive } from 'radix-ui';
import { ComponentProps } from 'react';

import { mergeClasses } from '@/utils';

export const Switch = ({
  className,
  size = 'default',
  disabled,
  ...props
}: ComponentProps<typeof SwitchPrimitive.Root> & {
  size?: 'sm' | 'default';
}) => {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      data-size={size}
      className={mergeClasses(
        'data-[state=checked]:bg-primary-base data-[state=unchecked]:bg-neutral-4 dark:data-[state=unchecked]:bg-neutral-9 focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 aria-invalid:border-destructive shrink-0 rounded-full border border-transparent focus-visible:ring-3 aria-invalid:ring-3 data-[size=default]:h-8 data-[size=default]:w-16 data-[size=sm]:h-6 data-[size=sm]:w-10 peer group/switch relative inline-flex items-center transition-all outline-none after:absolute after:-inset-x-3 after:-inset-y-2',
        disabled &&
          'cursor-not-allowed pointer-events-none data-[state=unchecked]:bg-neutral-1 data-[state=unchecked]:border data-[state=unchecked]:border-neutral-5',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={mergeClasses(
          'bg-neutral-0 rounded-full group-data-[size=default]/switch:size-6 group-data-[size=sm]/switch:size-4 group-data-[size=default]/switch:data-[state=checked]:translate-x-[calc(100%+10px)] group-data-[size=sm]/switch:data-[state=checked]:translate-x-[calc(100%+2px)] group-data-[size=default]/switch:data-[state=unchecked]:translate-x-1 group-data-[size=sm]/switch:data-[state=unchecked]:translate-x-1 pointer-events-none block ring-0 transition-transform',
          disabled && 'bg-neutral-5',
        )}
      />
    </SwitchPrimitive.Root>
  );
};
